export default __webpack_public_path__ + "static/media/gateway_activation.88addc22.png";